import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import './../../pagescss/SubjectTopics.css';
import PdfFiles from "../AllData/PdfFiles";
import StudyOption from "../AllData/HomeData";
import TopNavbar from "../home/TopNavbar";
import TopHeader from "../home/TopHeader";

const PDF_CACHE_NAME = 'pdf-files-v1';

function AllSubjectTopics({ subject, type }) {
  const allPdfs = PdfFiles;
  const [pdfs, setPdfs] = useState([]);
  const [bookmarkedPdfs, setBookmarkedPdfs] = useState([]);
  const [dounloadPdfs, setDounloadPdfs] = useState([]);
  const studyOptions = StudyOption;
  const matchingItem = studyOptions?.find(item => item.id === type);
  const iconName = matchingItem ? matchingItem.symbol : '📝';

  useEffect(() => {
    try {
      const filteredPdfs = allPdfs.filter(pdf =>
        pdf.subject === subject && pdf.type === type
      );
      setPdfs(filteredPdfs);
      const storedBookmarks = localStorage.getItem('pdfBookmarks');
      if (storedBookmarks) {
        setBookmarkedPdfs(JSON.parse(storedBookmarks));
      } else {
        setBookmarkedPdfs([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [subject, type]);

  useEffect(() => {
    const checkDownloadedPdfs = async () => {
      try {
        const cache = await caches.open(PDF_CACHE_NAME);
        const downloadedIds = [];
        for (const pdf of pdfs) {
          const cacheKey = `/pdf/${pdf.id}`;
          const cachedPdf = await cache.match(cacheKey);
          if (cachedPdf) {
            downloadedIds.push(pdf.id);
          }
        }
        console.log('Downloaded PDF IDs:', downloadedIds);
        setDounloadPdfs(downloadedIds);
      } catch (error) {
        console.error('Error checking PDF cache:', error);
      }
    };
    if (pdfs.length > 0) {
      checkDownloadedPdfs();
    } else {
      setDounloadPdfs([]);
    }
  }, [pdfs]);

  const toggleBookmark = (pdf) => {
    const isBookmarked = bookmarkedPdfs.some(
      bookmark => bookmark.pdfId === pdf.id
    );
    const storedBookmarks = localStorage.getItem('pdfBookmarks');
    let allBookmarks = storedBookmarks
      ? JSON.parse(storedBookmarks)
      : [];
    if (isBookmarked) {
      const updatedBookmarks = allBookmarks.filter(
        bookmark => bookmark.pdfId !== pdf.id
      );
      localStorage.setItem(
        'pdfBookmarks',
        JSON.stringify(updatedBookmarks)
      );
      setBookmarkedPdfs(updatedBookmarks);
    } else {
      const newBookmark = {
        pdfId: pdf.id,
        subject: pdf.subject,
        pdfData: pdf,
        timestamp: new Date().toISOString()
      };
      const updatedBookmarks = [
        ...allBookmarks,
        newBookmark
      ];
      localStorage.setItem(
        'pdfBookmarks',
        JSON.stringify(updatedBookmarks)
      );
      setBookmarkedPdfs(updatedBookmarks);
    }
  };

  return (
    <div className="subject-topics-page">
      <TopNavbar
        name={
          subject.charAt(0).toUpperCase() +
          subject.slice(1)
        }
      />
      <TopHeader
        name={
          subject.charAt(0).toUpperCase() +
          subject.slice(1)
        }
      />
      <div className="subject-categories">
        {pdfs.map((pdf) => {
          const isBookmarked = bookmarkedPdfs.some(
            bookmark => bookmark.pdfId === pdf.id
          );
          const isPdfDounloaded =
            dounloadPdfs.includes(pdf.id);
          return (
            <div
              className={`topic-card ${isBookmarked ? 'bookmarked' : ''
                }`}
              key={pdf.id}
            >
              <div
                className="bookmark-icon"
                onClick={() => toggleBookmark(pdf)}
                title={
                  isBookmarked
                    ? "Remove bookmark"
                    : "Add bookmark"
                }
              >
                {isBookmarked ? '★' : '☆'}
                {isBookmarked ? (
                  <p className="bookmarked-text">
                    Marked
                  </p>
                ) : (
                  <p className="bookmark-text">
                    Mark
                  </p>
                )}
              </div>
              {type === "formula" ||
                type === "flashcard" ||
                type === "ncertshortnote" ||
                type === "mindmap" ||
                type === "topernote" ||
                type === "ncertbook" ||
                type === "ncertsolution" ? (
                <Link
                  to={`/onlinereadbook/${type}/${subject}/${pdf.topic}`}
                  className="link"
                >
                  <p>
                    {iconName} {pdf.name}
                  </p>
                </Link>
              ) : (
                <Link
                  to={`/pdfviewer/${pdf.pdfPath}/${encodeURIComponent(pdf.name)}/${pdf.id}`}
                
                  className="link"
                >
                  <p>
                    {iconName} {pdf.name}
                  </p>
                  {isPdfDounloaded && (
                    <p
                      style={{
                        fontSize: "8px",
                        color: "green"
                      }}
                    >
                      Downloaded
                    </p>
                  )}
                </Link>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default AllSubjectTopics;